<template>
	<app-page>
		<app-heading :title="isNew ? 'New Complex' : complex.name" />
		<app-section style="width: 500px;" class="mt-4">
			<app-form @submit="onSubmit">
				<input-text
					label="Name"
					v-model="complex.name"
					required
					:errors="errors.name"
				/>
				<input-select
					label="City"
					:items="cities"
					v-model="complex.market_city"
					required
					:errors="errors.market_city"
				/>
				<input-select
					label="Area"
					:items="areas"
					v-model="complex.area"
					required
					:disabled="!complex.market_city"
					:errors="errors.area"
				/>
				<input-textarea
					label="Heading 2 (Website)"
					v-model="complex.heading2"
					required
					:errors="errors.heading2"
				/>
				<input-textarea
					label="Heading 3 (Website)"
					v-model="complex.heading3"
					required
					:errors="errors.heading3"
				/>
				<app-button type="submit" color="success" v-if="isNew">Create</app-button>
				<app-button type="submit" color="primary" v-else>Save</app-button>
				<app-button type="cancel" :to="{ name: 'market-complexes' }">Cancel</app-button>
			</app-form>
		</app-section>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			complex: {
				name: '',
				market_city: null,
				area: null,
				heading2: '',
				heading3: '',
			},
			cities: [],
			areas: [],
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.complex
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.complex = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('complexes')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}

		await this.fetchCities()
		this.$store.dispatch('app/stopLoading')
	},
	watch: {
		'complex.market_city': {
			async handler(newValue, oldValue) {
				if (oldValue && newValue !== oldValue) {
					this.complex.area = null
				}
				await this.fetchAreas()
			},
		},
	},
	methods: {
		async fetchCities() {
			this.cities = await this.$ravello.graphql('cities')
				.parent(this.$ravello.graphql('market', this.marketId))
				.datasource()
				.sort('name')
				.query()
		},
		async fetchAreas() {
			this.areas = await this.$ravello.graphql('areas')
				.parent(this.$ravello.graphql('market', this.marketId))
				.filter('market_city', this.complex.market_city)
				.datasource()
				.sort('name')
				.query()
		},
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const request = this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('complexes')

			const payload = {
				name: this.complex.name,
				market_city: this.complex.market_city,
				area: this.complex.area,
				heading2: this.complex.heading2,
				heading3: this.complex.heading3,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Complex successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'market-complexes' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
